export const defaultLang: string = 'pl';
